<template>
    <div class="container">
        <h2>??Edit</h2>
        <div v-if="mapObject">
            <h3>??Landmarks</h3>
            <ul>
                <li v-for="(landmark, index) of mapObject.landmarks" v-bind:key="index">
                    <input type="text" v-bind:value="landmark" v-on:change="onLandmarkChanged(index, $event)" />
                </li>
            </ul>
            <a href="#" v-on:click="addLandmark()">??Add landmark</a>
        </div>
        <div v-if="!mapObject">
            loading...
        </div>
        <button class="btn btn-primary" v-on:click="onSaveClicked()">??Save</button>
        <button class="btn btn-light" v-on:click="onCancelClicked()">??Cancel</button>
    </div>
</template>

<script>
import MapService from '@/service/MapService';

const mapService = new MapService();

export default {
    name: "MapObjectEditor",
    props: {
        publisherId: null,
        mapObjectId: null
    },
    data() {
        return {
            mapObject: null
        }
    },
    watch: {
        publisherId: function() {
            this.loadMapObject()
        },
        mapObjectId: function() {
            this.loadMapObject()
        }
    },
    methods: {
        loadMapObject() {
            this.mapObject = null;
            if (this.publisherId && this.mapObjectId) {
                mapService.loadMapObject(this.publisherId, this.mapObjectId).then((mapObject) => {
                    this.mapObject = mapObject;
                }).catch((error) => {
                    console.log(error);
                    // TODO
                });
            } else {
                console.log("missing");
            }
        },

        addLandmark() {
            console.log("adding");
            this.mapObject.landmarks.push("");
            console.log(this.mapObject.landmarks);
        },

        onLandmarkChanged(index, event) {
            this.mapObject.landmarks[index] = event.target.value;
            console.log(event);
        },

        onSaveClicked() {
            mapService.saveMapObject(this.publisherId, this.mapObject).then(() => {
                this.$emit("mapObjectSaved");
            }).catch((error) => {
                console.log(error);
                // TODO
            })
        },

        onCancelClicked() {
            this.$emit("cancel");
        }
    },
    mounted() {
        this.loadMapObject();
    }
}
</script>

<style scoped>
.container {
    padding: 20px;
    text-align: left;
}
</style>